<template>
  <v-icon :color="color" :size="size">
    {{ getDataSourceIcon(layerType) }}
  </v-icon>
</template>

<script>
import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';

export default {
  name: 'PermissionsLayerIcon',
  mixins: [stylePreviewUtilities],
  props: {
    color: {
      type: String,
      default: 'rgba(0,0,0,0.7)',
    },
    layerType: {
      type: String,
    },
    size: {
      type: [Number, String],
      default: '24px',
    },
  },
};
</script>
